import { addressFields } from '@lib/fragments/address-fragment';
import assetFragment from '@lib/fragments/asset-fragment';
import ctaFragment from '@lib/fragments/cta-fragment';
import { facilitiesFields } from '@lib/fragments/facilities';
import { localizationsFields } from '@lib/fragments/localizations-fragment';
import {
  sectionsFields,
  sectionsFragment,
} from '@lib/fragments/sections-fragment';
import { seoFields } from '@lib/fragments/seo-fragment';
import { socialsFields } from '@lib/fragments/socials-fragment';
import { tagFragment } from '@lib/fragments/tag-fragment';
import gql from 'graphql-tag';

const EVENT_PAGE_QUERY = gql`
  query EVENT_PAGE_QUERY($id: String, $slug: String, $locale: String) {
    EventPage(id: $id, slug: $slug, locale: $locale) {
      typename: __typename
      id: _id
      slug: _slug
      locales: _locales
      title
      introText: intro_text
      ctaHero: cta_hero { 
        ...ctaFields
      }
      tags: content_tags {
        ${tagFragment}
      }
      mail
      phone
      website
      ${socialsFields}
      location {
        # image used for richdata
        image {
          ...assetFields
          url(width: 600, format: "webp")
        }
        title
        slug: _slug
        coordinates {
          latitude
          longitude
        }
        address {
          ${addressFields}
        }
      }
      address {
        ${addressFields}
      }
      coordinates {
        latitude
        longitude
      }
      dates {
        from
        until
      }
      image {
        ...assetFields
        url(width: 1920, format: "webp")
      }
      # Legacy: alignment is managed with focal_point in image. Keep for backwards compatibility.
      alignment { 
        focusPoint: focus_point
      }
      heroColor: hero_color {
        color
      }
      youtubeId: youtube_id
      extraImages: extra_images {
        ...assetFields
        url(width: 800, height: 500, format: "webp")
      }
      # SubSub
      category {
        heroColor: hero_color {
          color
        }
        icon
        # Sub
        category {
          colorPalette: color_palette
          heroColor: hero_color {
            color
          }
          icon
          # Main
          category {
            colorPalette: color_palette
            heroColor: hero_color {
              color
            }
          }
        }
      }
      description
      descriptionIsCollapsible: description_is_collapsible
      cta {
        ...ctaFields
      }
      price
      facilities {
        ${facilitiesFields}
      }
      ${localizationsFields}
      ${sectionsFields}
      ${seoFields}
    }
  }
  ${assetFragment}
  ${sectionsFragment}
  ${ctaFragment}
`;

export default EVENT_PAGE_QUERY;
